import { useState, useEffect } from 'react'
import useAuthStore from '../../store/authStore.js'
import { useLanguage } from '../../i18n/index.jsx'

export default function DemoTimer() {
  const { demoExpiresAt, logout } = useAuthStore()
  const { t } = useLanguage()
  const [remaining, setRemaining] = useState<number | null>(null)

  useEffect(() => {
    if (!demoExpiresAt) return

    const update = () => {
      const diff = new Date(demoExpiresAt).getTime() - Date.now()
      if (diff <= 0) {
        logout()
        return
      }
      setRemaining(diff)
    }

    update()
    const interval = setInterval(update, 1000)
    return () => clearInterval(interval)
  }, [demoExpiresAt, logout])

  if (!demoExpiresAt || remaining === null) return null

  const minutes = Math.floor(remaining / 60000)
  const seconds = Math.floor((remaining % 60000) / 1000)
  const timeStr = `${minutes}:${seconds.toString().padStart(2, '0')}`
  const isWarning = remaining < 5 * 60 * 1000 // under 5 minutes

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
      padding: '8px 12px', margin: '0 0.75rem 0.5rem',
      borderRadius: 'var(--radius)',
      fontSize: 'var(--text-sm)', fontWeight: 600,
      background: isWarning ? 'rgba(239, 68, 68, 0.15)' : 'rgba(139, 92, 246, 0.12)',
      color: isWarning ? 'var(--danger)' : 'var(--text-secondary)',
      border: `1px solid ${isWarning ? 'rgba(239, 68, 68, 0.3)' : 'rgba(139, 92, 246, 0.25)'}`,
      animation: isWarning && remaining < 60000 ? 'pulse 1s infinite' : 'none',
    }}>
      <span style={{ textTransform: 'uppercase', letterSpacing: '0.04em', fontSize: 'var(--text-tiny)' }}>{t('demoLabel')}</span>
      <span style={{ fontFamily: 'var(--font-mono, monospace)' }}>{timeStr}</span>
      {isWarning && (
        <a href="/login" onClick={e => { e.preventDefault(); window.location.href = '/login' }}
          style={{ fontSize: 'var(--text-xs)', color: 'var(--accent)', textDecoration: 'underline', cursor: 'pointer' }}>
          {t('signUp')}
        </a>
      )}
    </div>
  )
}
